module.exports = __webpack_public_path__ + "img/lawnstarter_green.dc141271.svg";